import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';

import {

  clearAuthToken,

  loadAuthToken,

  loginRequest,

  logoutRequest,

  setAuthToken,

  getGmailLeads,
  getMyProfile,

} from '../api/client';

import { prefetchReplyPrompts } from '../utils/replySettingsCache';
import { ROLE_OWNER } from '../utils/roles';



const AuthContext = createContext();



const LAST_SEEN_LEAD_KEY = 'gradient:lastSeenLeadTime';

const LEAD_SNAPSHOT_KEY = 'gradient:displayedLeadSnapshot';

const USER_PROFILE_KEY = 'gradient:userProfile';

const readUserProfile = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(USER_PROFILE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (storageError) {
    console.error('Не вдалося зчитати профіль користувача', storageError);
    return null;
  }
};

const writeUserProfile = (user) => {
  if (typeof window === 'undefined' || !user) return;
  try {
    window.localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(user));
  } catch (storageError) {
    console.error('Не вдалося зберегти профіль користувача', storageError);
  }
};

const clearUserProfile = () => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(USER_PROFILE_KEY);
  } catch (storageError) {
    console.error('Не вдалося очистити профіль користувача', storageError);
  }
};



const readLastSeenLeadTime = () => {

  if (typeof window === 'undefined') return null;

  try {

    return window.localStorage.getItem(LAST_SEEN_LEAD_KEY);

  } catch (storageError) {

    console.error('Не вдалося зчитати час перегляду листів', storageError);

    return null;

  }

};



const writeLastSeenLeadTime = (isoString) => {

  if (typeof window === 'undefined' || !isoString) return;

  try {

    window.localStorage.setItem(LAST_SEEN_LEAD_KEY, isoString);

  } catch (storageError) {

    console.error('Не вдалося зберегти час перегляду листів', storageError);

  }

};



const clearLastSeenLeadTime = () => {

  if (typeof window === 'undefined') return;

  try {

    window.localStorage.removeItem(LAST_SEEN_LEAD_KEY);

  } catch (storageError) {

    console.error('Не вдалося очистити час перегляду листів', storageError);

  }

};



const readLeadSnapshot = () => {

  if (typeof window === 'undefined') return null;

  try {

    const raw = window.localStorage.getItem(LEAD_SNAPSHOT_KEY);

    if (!raw) return null;

    return JSON.parse(raw);

  } catch (storageError) {

    console.error('Не вдалося зчитати збережені ліди', storageError);

    return null;

  }

};



const writeLeadSnapshot = (payload) => {

  if (typeof window === 'undefined') return;

  try {

    if (payload) {

      window.localStorage.setItem(LEAD_SNAPSHOT_KEY, JSON.stringify(payload));

    } else {

      window.localStorage.removeItem(LEAD_SNAPSHOT_KEY);

    }

  } catch (storageError) {

    console.error('Не вдалося зберегти ліди', storageError);

  }

};



const parseDateOrNull = (value) => {

  if (!value) return null;

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;

};



const formatRelativeTime = (value) => {

  if (!value) return '';

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return '';

  const diffMs = Date.now() - date.getTime();

  const minutes = Math.floor(diffMs / (1000 * 60));

  if (minutes < 1) return 'щойно';

  if (minutes < 60) return `${minutes} хв тому`;

  const hours = Math.floor(minutes / 60);

  if (hours < 24) return `${hours} год тому`;

  const days = Math.floor(hours / 24);

  if (days === 1) return 'вчора';

  if (days < 7) return `${days} дн. тому`;

  const weeks = Math.floor(days / 7);

  if (weeks < 5) return `${weeks} тиж. тому`;

  const months = Math.floor(days / 30);

  if (months < 12) return `${months} міс. тому`;

  const years = Math.floor(months / 12);

  return `${years} р. тому`;

};



const formatEmailCountMessage = (count) => {

  if (count === 0) {

    return 'Нових листів немає.';

  }

  if (count === 1) {

    return 'Вам надійшов 1 новий лист.';

  }

  return `Вам надійшло ${count} нових листів.`;

};

const decodeJwtPayload = (tokenValue) => {
  if (!tokenValue || typeof tokenValue !== 'string') return null;
  const parts = tokenValue.split('.');
  if (parts.length < 2) return null;

  try {
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = atob(padded);
    return JSON.parse(json);
  } catch (error) {
    console.warn('Failed to decode JWT payload', error);
    return null;
  }
};


export const AuthProvider = ({ children }) => {

  const [token, setToken] = useState(null);

  const [user, setUser] = useState(null);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

  const [notifications, setNotifications] = useState([]);

  const notificationTimersRef = useRef({});

  const [leadSnapshot, setLeadSnapshot] = useState(() => readLeadSnapshot());

  const loginSnapshotRef = useRef(null);



  const removeNotification = useCallback((id) => {

    setNotifications((prev) => prev.filter((item) => item.id !== id));

    const timeoutId = notificationTimersRef.current[id];

    if (timeoutId) {

      clearTimeout(timeoutId);

      delete notificationTimersRef.current[id];

    }

  }, []);



  const pushNotification = useCallback(

    (notification) => {

      const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

      const entry = {

        id,

        createdAt: new Date().toISOString(),

        duration: 9000,

        variant: 'info',

        ...notification,

      };

      setNotifications((prev) => [...prev, entry]);



      if (entry.duration !== 0) {

        const timeoutId = setTimeout(() => {

          removeNotification(id);

        }, entry.duration || 9000);

        notificationTimersRef.current[id] = timeoutId;

      }

    },

    [removeNotification]

  );



  useEffect(() => () => {

    Object.values(notificationTimersRef.current).forEach((timeoutId) => {

      clearTimeout(timeoutId);

    });

    notificationTimersRef.current = {};

  }, []);



  useEffect(() => {
    const onSessionExpired = () => {
      setToken(null);
      setUser(null);
      clearUserProfile();
      setLeadSnapshot(null);
      writeLeadSnapshot(null);
      setError('Сесія закінчилась. Увійдіть знову.');
    };

    window.addEventListener('auth:session-expired', onSessionExpired);
    return () => window.removeEventListener('auth:session-expired', onSessionExpired);
  }, []);



  useEffect(() => {

    const storedToken = loadAuthToken();

    if (storedToken) {

      setToken(storedToken);

      // Hydrate user from JWT so role-based menus survive refresh/reload.
      setUser((prev) => {
        if (prev) return prev;
        const payload = decodeJwtPayload(storedToken);
        const role = payload?.role || 'manager';
        const username = payload?.sub || null;
        const cached = readUserProfile();
        return {
          username: cached?.username || username || 'User',
          email: cached?.email || username || 'User',
          role: cached?.role || role,
          id: cached?.id ?? null,
          avatar_url: cached?.avatar_url || '',
        };
      });

    }

  }, []);

  useEffect(() => {
    if (!token) return;
    const cachedProfile = readUserProfile();
    if (cachedProfile?.role === ROLE_OWNER) {
      void prefetchReplyPrompts();
    }
  }, [token]);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    const hydrateProfile = async () => {
      try {
        const profile = await getMyProfile();
        if (cancelled || !profile) return;
        setUser((prev) => {
          const next = {
            ...(prev || {}),
            id: profile.id ?? prev?.id ?? null,
            username: profile.username || prev?.username || 'User',
            email: profile.email || prev?.email || '',
            role: profile.role || prev?.role || 'manager',
            avatar_url: profile.avatar_url || '',
          };
          writeUserProfile(next);
          return next;
        });
        if (profile.role === ROLE_OWNER) {
          void prefetchReplyPrompts();
        }
      } catch (error) {
        console.warn('Не вдалося завантажити профіль користувача', error);
      }
    };
    hydrateProfile();
    return () => {
      cancelled = true;
    };
  }, [token]);



  const logout = useCallback(async () => {

    try {
      await logoutRequest();
    } catch (logoutError) {
      console.warn('Не вдалося повідомити сервер про вихід', logoutError);
    }

    clearAuthToken();

    setToken(null);

    setUser(null);
    clearUserProfile();

    setError(null);

    setNotifications([]);

    Object.values(notificationTimersRef.current).forEach((timeoutId) => {

      clearTimeout(timeoutId);

    });

    notificationTimersRef.current = {};

    setLeadSnapshot(null);

    writeLeadSnapshot(null);

    clearLastSeenLeadTime();

  }, []);

  const updateUserAvatar = useCallback((avatarUrl) => {
    setUser((prev) => {
      const next = { ...(prev || {}), avatar_url: avatarUrl || '' };
      writeUserProfile(next);
      return next;
    });
  }, []);

  const hydrateLoginLeads = useCallback(async () => {
    try {
      const leadsPayload = await getGmailLeads(null, { lightweight: true });
      const leads = leadsPayload?.leads ?? [];
      const sortedLeads = [...leads]
        .map((lead) => ({
          ...lead,
          _receivedAt: parseDateOrNull(lead.received_at),
        }))
        .filter((lead) => lead._receivedAt)
        .sort((a, b) => b._receivedAt.getTime() - a._receivedAt.getTime());

      const newestLead = sortedLeads[0] ?? null;
      loginSnapshotRef.current = leadsPayload;
      setLeadSnapshot(leadsPayload);
      writeLeadSnapshot(leadsPayload);

      const lastSeenIso = readLastSeenLeadTime();
      const lastSeenDate = parseDateOrNull(lastSeenIso);
      const newLeadCount = sortedLeads.reduce((acc, lead) => {
        if (!lastSeenDate) {
          return acc + 1;
        }
        return lead._receivedAt > lastSeenDate ? acc + 1 : acc;
      }, 0);

      if (newestLead) {
        const relative = formatRelativeTime(newestLead.received_at);
        pushNotification({
          variant: newLeadCount ? 'success' : 'info',
          title: newLeadCount ? 'Вам надійшли нові листи' : 'Нові листи відсутні',
          message: newLeadCount
            ? `${formatEmailCountMessage(newLeadCount)}${relative ? ` Останній отримано ${relative}.` : ''}`
            : relative
              ? `Останній лист отримано ${relative}.`
              : 'Вхідні актуальні, ви нічого не пропустили.',
          duration: 0,
        });
      } else {
        pushNotification({
          variant: 'info',
          title: 'Вхідні порожні',
          message: 'Наразі у вас немає листів для обробки.',
          duration: 0,
        });
      }
    } catch (notifyError) {
      console.error('Не вдалося завантажити інформацію про листи після входу', notifyError);
    }
  }, [pushNotification]);

  const login = useCallback(async ({ email, password }) => {

    setLoading(true);

    setError(null);

    try {

      const payload = {

        username: email,

        email,

        password,

      };



      const response = await loginRequest(payload);

      const receivedToken = response?.access_token;

      const userRole = response?.role || 'manager';



      if (!receivedToken) {

        throw new Error('Не вдалося отримати токен доступу.');

      }



      setAuthToken(receivedToken);

      setToken(receivedToken);

      const profile = response?.user;
      const nextUser = profile
        ? {
            id: profile.id ?? null,
            username: profile.username || email,
            email: profile.email || email,
            role: profile.role || userRole,
            avatar_url: profile.avatar_url || '',
          }
        : {
            id: null,
            email,
            username: email,
            role: userRole,
            avatar_url: '',
          };

      setUser(nextUser);
      writeUserProfile(nextUser);

      void hydrateLoginLeads();
      if (nextUser.role === ROLE_OWNER) {
        void prefetchReplyPrompts();
      }

      return { success: true };

    } catch (err) {

      const message = err?.message || 'Помилка авторизації.';

      setError(message);

      return { success: false, error: message };

    } finally {

      setLoading(false);

    }

  }, [hydrateLoginLeads]);



  const updateLeadSnapshot = useCallback(

    (payload, { isManualRefresh = false } = {}) => {

      const snapshot = payload ?? loginSnapshotRef.current ?? null;

      setLeadSnapshot(snapshot);

      writeLeadSnapshot(snapshot);



      const leadsArray = snapshot?.leads ?? [];

      const newestDisplayed = leadsArray

        .map((lead) => parseDateOrNull(lead.received_at))

        .filter(Boolean)

        .sort((a, b) => b.getTime() - a.getTime())[0];



      if (newestDisplayed) {

        writeLastSeenLeadTime(newestDisplayed.toISOString());

      } else if (snapshot) {

        writeLastSeenLeadTime(new Date().toISOString());

      }



      if (isManualRefresh) {

        loginSnapshotRef.current = snapshot;

      }

    },

    []

  );



  const value = useMemo(

    () => ({

      token,

      user,

      loading,

      error,

      isAuthenticated: Boolean(token),

      login,

      logout,

      clearError: () => setError(null),

      notifications,

      pushNotification,

      removeNotification,

      leadSnapshot,

      updateLeadSnapshot,
      setUser,
      updateUserAvatar,

    }),

    [

      token,

      user,

      loading,

      error,

      login,

      logout,

      notifications,

      pushNotification,

      removeNotification,

      leadSnapshot,

      updateLeadSnapshot,
      setUser,
      updateUserAvatar,

    ]

  );



  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;

};



export const useAuth = () => {

  const context = useContext(AuthContext);

  if (!context) {

    throw new Error('useAuth мусить використовуватися всередині AuthProvider');

  }

  return context;

};

